export const SUPPORT_TICKET_TABS = ["Tickets", "Cases", "Custom"] as const;

export type SupportTicketsTab = (typeof SUPPORT_TICKET_TABS)[number];

export const SUPPORT_TICKET_PRESET_TABS = ["Tickets", "Cases"] as const;

export type SupportTicketsPresetTab = (typeof SUPPORT_TICKET_PRESET_TABS)[number];

export function isSupportTicketsPresetTab(
  value: string
): value is SupportTicketsPresetTab {
  return SUPPORT_TICKET_PRESET_TABS.includes(value as SupportTicketsPresetTab);
}
